import { darken } from 'polished';
import styled from 'styled-components';

export const ContainerDados = styled.div`
  background-color: #fff;
  padding: 6px;
  border: 1px solid #d7d7d7;
  font-size: 0.8rem;
  min-height: 388px;
`;

export const FileInput = styled.div`
  position: relative;
  /* align-self: center; */
  img {
    width: 100%;
    max-width: 175px;
    max-height: 120px;
    border-radius: 8px;
  }
  label {
    /* position: absolute;
     width: 48px; */
    padding: 0 10px;
    height: 30px;
    margin-bottom: 0;
    background: #fff;
    border-radius: 4px;
    /* right: 3px;
    bottom: 0; */
    border: 1px solid #cecece;
    transition: background-color 0.2s svg {
      width: 20px;
      height: 20px;
    }
    cursor: pointer;
    input {
      display: none;
    }
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      margin-left: 6px;
      color: #007bff;
    }
    &:hover {
      border-color: ${darken(0.2, '#cecece')};
      background-color: #cecece;
    }
  }
`;
